import { useEffect, useState } from 'react';

const useZoomAnimation = (
  duration,
  elementRef,
  trigger,
  widthOffset,
  zoomFactor,
) => {
  const [imageStyles, setImageStyles] = useState({});

  useEffect(() => {
    const triggerAnimation = () => {
      const elementRect = elementRef.current?.getBoundingClientRect();

      if (!elementRect) {
        return;
      }

      if (trigger) {
        // highest value equals full viewport width
        const viewportWidth = Math.max(
          document.documentElement.clientWidth || 0,
          window.innerWidth || 0,
        );

        // zoomed element's width must not be larger than viewportWidth
        const selectedWidth =
          elementRect.width * zoomFactor > viewportWidth
            ? viewportWidth - widthOffset
            : elementRect.width * zoomFactor;

        // Height depends on selected width and has to be adapted proportionately
        const calculatedHeight =
          elementRect.width * zoomFactor > viewportWidth
            ? (elementRect.height / elementRect.width) * selectedWidth
            : elementRect.height * zoomFactor;

        setImageStyles({
          left: `calc(50% - ${selectedWidth}px / 2)`,
          top: `calc(50% - ${calculatedHeight}px / 2)`,
          width: selectedWidth,
          height: calculatedHeight,
          transition: `all ${duration}s ease-in-out`,
        });
      } else {
        setImageStyles({
          left: elementRect.left,
          width: elementRect.width,
          top: elementRect.top,
          height: elementRect.height,
          transition: `all ${duration}s ease-in-out`,
        });
      }
    };

    triggerAnimation();

    window.addEventListener('resize', triggerAnimation);
    window.addEventListener('scroll', triggerAnimation);

    return () => {
      window.removeEventListener('resize', triggerAnimation);
      window.removeEventListener('scroll', triggerAnimation);
    };
  }, [trigger]);

  return imageStyles;
};

useZoomAnimation.defaultProps = {
  duration: 0.5,
  widthOffset: 0,
  zoomFactor: 1.2,
};

export default useZoomAnimation;
